import "lib/@hooks/useEvent"
import { useReducer } from "react"
import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { DraftEdited } from "../schedule-editor-event-definitions.mjs"

/**
 * Bumps when scoped field edits should refresh recommendation conflict state.
 *
 * @returns {number}
 */
export function useScheduleEditorDraftEditedVersion() {
    const { draftId } = useScheduleEditorIds()
    const [version, bumpVersion] = useReducer(incrementVersion, 0)

    DraftEdited(draftId).useEvent(bumpVersion)

    return version
}

function incrementVersion(current) {
    return current + 1
}
